import { types } from 'mobx-state-tree';

const SelectOption = types.model('SelectOption', {
  text: types.string,
  value: types.number,
});

export default SelectOption;
